export const DEFAULT_INCOME_TYPE = 'W2 Income';
export const INCOME_FREQUENCY = {
  annual: 'Annual',
  monthly: 'Monthly',
};
